import axios from 'axios';
import { history } from '../_helpers';
import config from '../config/config';
import alerts from '../_components/alerts';

export const crudService = {
    get,
    post,
    postNgrokUrl,
    put,
    deleteDetail
};
function get(apiEndpoint) {
    return axios.get(config.baseUrl + apiEndpoint, getOptions())
        .then((response) => {
            return response;
        }).catch((err) => {
            console.log(err);
        })
}
function post(apiEndpoint, payload) {
    return axios.post(config.baseUrl + apiEndpoint, payload, getOptions())
        .then((response) => {
            if (response.status === 401) {
                logout();
            } else if (response.status === 403) {
                history.push("/erro403");
            } else {
                return response;
            }
        }).catch((err) => {
            if (err.response.status === 401) {
                logout();
            } else if (err.response.status === 403) {
                history.push("/erro403");
            } else {
                console.log(err);
            }
            return err;
        });
}
function postNgrokUrl(apiEndpoint, payload) {

    return axios.post(apiEndpoint, payload, getOptions())
        .then((response) => {
            if (response.status === 401) {
                logout();
            } else if (response.status === 403) {
                history.push("/erro403");
            } else {
                return response;
            }
        }).catch((err) => {
            if (err.response.status === 401) {
                logout();
            } else if (err.response.status === 403) {
                history.push("/erro403");
            } else {
                console.log(err);
            }
            return err;
        });
}

function put(apiEndpoint, payload) {
    return axios.put(config.baseUrl + apiEndpoint, payload, getOptions())
        .then((response) => {
            if (response.status === 401) {
                logout();
            } else if (response.status === 403) {
                history.push("/erro403");
            } else {
                return response;
            }
        }).catch((err) => {
            if (err.response.status === 401) {
                logout();
            } else if (err.response.status === 403) {
                history.push("/erro403");
            } else {
                console.log(err);
            }
            return err;
        });
}
function deleteDetail(apiEndpoint) {
    return axios.delete(config.baseUrl + apiEndpoint, getOptions())
        .then((response) => {
            console.log('response', response)
            if (response.status === 401) {
                logout();
            } else if (response.status === 403) {
                history.push("/erro403");
            } else {
                return response;
            }
        }).catch((err) => {
            if (err.response.status === 401) {
                logout();
            } else if (err.response.status === 403) {
                history.push("/erro403");
            } else {
                console.log(err);
            }
            return err;
        });
}
function getOptions() {
    //let options = {};
    //if (localStorage.getItem('token')) {
    //    options.headers = { 'Authorization': 'Bearer ' + localStorage.getItem('token') };
    //}
    //return options;
    let options = {};
    let authdata = window.btoa(localStorage.getItem('token'));
    //let authdata = window.btoa('gestorrp:gestor2414#');
    options.headers = { 'Authorization': 'Basic ' + authdata };
    return options;
}

function getOptionsAllowCors() {
    let options = {};
    var token = localStorage.getItem('token');
    if (token === undefined || token === null) {
        token = 'gestorrp:gestor2414#';
    }
    let authdata = window.btoa(token);
    options.headers = {
        'Authorization': 'Basic ' + authdata,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
        'Access-Control-Allow-Headers': 'Content-Type, Authorization'
    };
    return options;
}
function logout() {
    localStorage.removeItem('auth');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    history.push('/');
    alerts.alert("Sessão encerrada. Realize login novamente.");
}